export const trimLeadingZeros = (inputValue) => String(Number(inputValue));
